<template lang='pug'>
  .form_group.design
    .form_item
      label Title
      el-input(
        v-model='title'
        @input="update_title"
      )
      .form_error
    .form_item
      label Description
      el-input(
        v-model='description'
        @input="update_description"
      )
      .form_error
    .form_item
      label Global Font
      el-select(
        :value="global_font_value"
        placeholder="Select"
        @change="update_global_font"
      )
        el-option(
          v-for="item in global_font_select"
          :key="item"
          :value="item"
        )
          span(:style="{fontFamily: item}") {{item}}

      .form_error
    .form_item
      label Background Color
      pbxx_color_picker(
        :color='background_color'
        @input="update_background_color")
      .form_error
    .form_item
      label Link Color
      pbxx_color_picker(
        :color='link_color'
        @input="update_link_color")
      .form_error
    .google_upload_item
      label Add a Google Font
      el-select(
        class="google_input"
        filterable
        :loading="fonts_loading"
        v-model="selected_google_font"
        @change="add_google_font"
        )
        el-option(
          v-for="font in font_families"
          :key="font"
          :label="font"
          :value="font"
          :style="{fontFamily: font}"
          )
      el-tag(
        :style="{marginRight: '5px', marginBottom: '5px', display: 'inline-block'}"
        v-for="font in selected_fonts"
        :key="font"
        :label="font"
        :value="font"
        @close="remove_google_font(font)"
        closable
        )
        span(:style="{fontFamily: font, fontSize: '20px'}") {{font}}
    .form_item
      label
        | Upload a custom font
      input(
        ref='upload_input'
        type='file',
        @change='upload_font',
        :style="{display: 'none'}"
      )
      .custom_upload
        .custom_input
          el-input(
            v-model='custom_font_name'
            placeholder="Name your font"
          )
        .custom_button
          el-button(
          :loading="this.uploading_custom_font"
            @click='trigger_upload'
          )
            | Click to upload
    el-tag(
      :style="{marginRight: '5px', marginBottom: '5px'}"
      v-for="font in custom_fonts"
      :key="font.family"
      :value="font.family"
      @close="remove_custom_font(font.family)"
      closable
    )
      span(:style="{fontFamily: font.family, fontSize: '20px'}") {{font.family}}
    //- Commenting out. Will be added back later
    //- .form_item
    //-   label Custom CSS
    //-   el-input(
    //-     :rows="8"
    //-     type="textarea"
    //-     :value='custom_css'
    //-     placeholder="Insert custom CSS here"
    //-     @input="update_custom_css"
    //-   )
    //-   .form_error
    //- .form_item
    //-   label Custom Events
    //-   el-input(type="text" v-model="custom_events")
    //-   .form_error
    //- .form_item
    //-   label Google Analytics ?
    //-   el-input(type="textarea")
    //-   .form_error
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'
  import add_font_dom from '../utils/add_font_dom'
  import { db, storage} from '../utils/firebase'

  const options = [
    {
      name: "Lato",
      family: "Lato"
    },
    {
      name: "Lucida Sans",
      family: "Lucida Sans Unicode"
    },
    {
      name: "Open Sans",
      family: "Open Sans"
    },
    {
      name: "Trebuchet",
      family: "Trebuchet MS"
    },
    {
      name: "Source Sans Pro",
      family: "Source Sans Pro"
    },
    {
      name: "Roboto",
      family: "Roboto"
    }
  ]
  export default {
    name: 'settings',
    props: {
      landing_page: {
        type: Object,
        required: true
      },
      campaign_id: {
        type: String,
        required: true
      },
      brand_id: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        fonts_loading: true,
        google_fonts: [],
        custom_font_name: "",
        uploading_custom_font: false,
        selected_google_font: "",
        uploading_file: {},
        brand: {},
        title: '',
        description: '',
        options,
        custom_events: ''
      }
    },
    computed: {
      custom_fonts() {
        return this.brand.custom_fonts || []
      },
      font_families() {
        return this.google_fonts.map(font => font.family)
      },
      global_font_select() {
        return [...options.map(font => font.family), ...this.selected_fonts, ...this.custom_fonts.map(font => font.family)]
      },
      selected_fonts() {
        return this.brand.fonts ? this.brand.fonts.map(font => font.family) : []
      },
      global_font_value() {
        return this.landing_page.global_font ? this.landing_page.global_font : 'Roboto'
      },
      background_color() {
        return this.landing_page.background_color ? this.landing_page.background_color : '#ffffff'
      },
      link_color() {
        return this.landing_page.link_color ? this.landing_page.link_color : '#63D1EB'
      },
      custom_css() {
        return this.landing_page.custom_css ? this.landing_page.custom_css : ""
      }
    },
    firestore() {
      return {
        brand: db.doc(`brands/${this.brand_id}`),
      }
    },
    methods: {
      trigger_upload() {
        this.uploading_custom_font = true
        this.$refs.upload_input.click()
      },
      async upload_font() {
        this.file = this.$refs.upload_input.files[0]
        this.uploading_file = storage.child(`${this.brand.slug}/${this.custom_font_name}`).put(this.file)
        this.uploading_file.on('state_changed', this.upload_progress, this.upload_error, this.upload_complete)
      },
      upload_progress(snapshot) {
        this.file_upload_progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      },
      async upload_complete(snapshot) {
        const family = this.custom_font_name
        const url = await storage.child(`${this.brand.slug}/${family}`).getDownloadURL()
        const custom_fonts = this.brand.custom_fonts || []
        await add_font_dom({family,url})
        custom_fonts.push({family,url})
        await db.doc(`brands/${this.brand.id}`).update({custom_fonts})
        this.uploading_custom_font = false
        this.custom_font_name = ""
      },
      remove_custom_font(family){
        if(family === this.global_font_value) return
        const custom_fonts = this.brand.custom_fonts
        const filtered_fonts = custom_fonts.filter(font => font.family !== family)
        db.doc(`brands/${this.brand.id}`).update({custom_fonts: filtered_fonts})
      },
      add_google_font(font) {
        const new_array = [...this.selected_fonts, font]
        const unique_values = _.uniq(new_array)
        const objects = unique_values.map(value => {
          return this.google_fonts.find(element => element.family === value)
        })
        db.doc(`brands/${this.brand_id}`).update({
          fonts: objects
        })
      },
      remove_google_font(name) {
        if(name === this.global_font_value) return
        const new_array = this.selected_fonts.filter(font => font !== name)
        const objects = new_array.map(value => {
          return this.google_fonts.find(element => element.family === value)
        })
        db.doc(`brands/${this.brand_id}`).update({
          fonts: objects
        })
      },
      set_description() {
        this.description = this.landing_page.description
      },
      set_title() {
        this.title = this.landing_page.title
      },
      update_title(title) {
        db.doc(`landing_pages/${this.campaign_id}`).update({ title })
      },
      update_description(description) {
        db.doc(`landing_pages/${this.campaign_id}`).update({ description })
      },
      update_background_color(background_color) {
        db.doc(`landing_pages/${this.campaign_id}`).update({ background_color })
      },
      update_global_font(global_font) {
        db.doc(`landing_pages/${this.campaign_id}`).update({ global_font })
      },
      update_link_color(link_color) {
        db.doc(`landing_pages/${this.campaign_id}`).update({ link_color })
      }
    },
    async mounted() {
      const change_fonts_loading = () => {
        this.fonts_loading = false
      }
      this.set_title()
      this.set_description()
      const google_fonts = await axios.get("https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyB-_65GUVrPNqYN_Uh_jWiu5F0wSy-l49M&sort=popularity")
      const font_families = google_fonts.data.items.map(font => font.family)
      this.google_fonts = google_fonts.data.items

      WebFont.load({
        google: {
          families: font_families
        },
        active: function () {
          change_fonts_loading()
        },
      });
    }
  }
</script>

<style lang='scss' scoped>
  .design {
    padding: 20px;
  }
  .google_upload_item {
    margin-bottom: 20px
  }
  .custom_upload {
    margin-bottom: 15px
  }
  .google_input {
    margin-bottom: 15px;
  }
  .custom_input {
    width: 50%;
    display: inline-block;
  }
  .custom_button {
    display: inline-block;
    margin-left: 10px;
  }
</style>
